import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  signInWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  signInContentWrapper: {
    ...theme.mixins.appContainer,
    width: '480px',
    padding: theme.spacing(4, 2),

    [theme.breakpoints.down('md')]: {
      position: 'relative',
      width: '100%',
      height: '100%',
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  desktopLanguageSelector: {
    position: 'fixed',
    top: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: theme.zIndex.appBar,
  },
  mobileLanguageSelector: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  signInForm: {
    width: '100%',
  },

  signInRole: {
    textTransform: 'capitalize',
  },

  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },

  signInForgotPasswordButton: {
    width: '100%',
    textAlign: 'right',
    marginTop: '8px',
    marginBottom: '32px',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 400,
    fontSize: '14px',

    a: {
      color: theme.palette.primary.main,

      '&:hover': {
        color: theme.palette.primary.dark,
      },
    },
  },
  signInModeSwitcher: {
    textAlign: 'center',
    width: '100%',
    marginTop: '24px',
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.font.secondary,
  },
  signInModeSwitcherButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  signInDivider: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '16px',
    marginBottom: '16px',
    color: theme.palette.grey[600],

    '& span': {
      marginLeft: '8px',
      marginRight: '8px',
      fontSize: '16px',
    },
    '& div': {
      flex: 1,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
  },
  signInButtonWithIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    width: '100%',

    svg: {
      width: '16px',
      height: '16px',
    },
  },
}));
